import { IsiDtoPlPerformanceAnalyserRequest, IsiDtoPlPerformanceAnalyserResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlPerformanceAnalyser";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlPerformanceAnalyser extends IsiPresentationLogic {

    constructor() {
        super("IsiPlPerformanceAnalyserHandler");
    }

    /*
    * Démarrage d'une anamyse de performances
    */
    public async StartPerformanceMesure(): Promise<IIsiUIFlowResult> {
        let params = IsiDtoPlPerformanceAnalyserRequest.fromJS({
            response: IsiDtoPlPerformanceAnalyserResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlPerformanceAnalyserRequest> = await this.ajaxWithErrorHandling("StartPerformanceMesure", params, true);

        if (result?.continue === false) {
            return result;
        }
        return { continue: true, result: true }
    }

    /*
    * Arrêt d'une anamyse de performances
    */
    public async StopPerformanceMesure(): Promise<IIsiUIFlowResult> {
        let params = IsiDtoPlPerformanceAnalyserRequest.fromJS({
            response: IsiDtoPlPerformanceAnalyserResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlPerformanceAnalyserRequest> = await this.ajaxWithErrorHandling("StopPerformanceMesure", params, true);

        if (result?.continue === false) {
            return result;
        }
        return { continue: true, result: true }
    }

    /*
    * Reset d'une analyse de performances
    */
    public async ResetPerformanceMesure(): Promise<IIsiUIFlowResult> {
        let params = IsiDtoPlPerformanceAnalyserRequest.fromJS({
            response: IsiDtoPlPerformanceAnalyserResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlPerformanceAnalyserRequest> = await this.ajaxWithErrorHandling("ResetPerformanceMesure", params, true);

        if (result?.continue === false) {
            return result;
        }
        return { continue: true, result: true }
    }


    /*
    * Traitement d'analyse des performances client
    */
    public async PerformanceAnalyserClient(screen: string, endTime: string, onLoadTime: string): Promise<IIsiUIFlowResult> {
        let params = IsiDtoPlPerformanceAnalyserRequest.fromJS({
            screenId: screen,
            pageEndStartTime: endTime,
            pageOnLoadEndStartTime: onLoadTime,
            response: IsiDtoPlPerformanceAnalyserResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlPerformanceAnalyserRequest> = await this.ajaxWithErrorHandling("AnalysePerformanceClient", params, true);

        if (result?.continue === false) {
            return result;
        }
        return { continue: true, result: true }
    }

}